import { queryClient } from "@/utils/clients/orpc";
import type { TRouteContext } from "@/utils/types";
import { HeroUIProvider, Spinner, ToastProvider } from "@heroui/react";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { Outlet, createRootRouteWithContext } from "@tanstack/react-router";

export const Route = createRootRouteWithContext<TRouteContext>()({
  component: Component,
  pendingComponent: () => (
    <div className="flex h-screen items-center justify-center">
      <Spinner size="lg" />
    </div>
  ),
  errorComponent: ({ error }) => (
    <div className="flex h-screen flex-col items-center justify-center gap-4 p-8">
      <h1 className="text-danger text-2xl font-bold">Something went wrong</h1>
      <p className="text-default-500">{error.message}</p>
    </div>
  ),
  notFoundComponent: () => (
    <div className="flex h-screen flex-col items-center justify-center gap-4 p-8">
      <h1 className="text-2xl font-bold">Page not found</h1>
      <p className="text-default-500">The page you're looking for doesn't exist.</p>
    </div>
  ),
});

function Component() {
  return (
    <HeroUIProvider>
      <ToastProvider />
      <QueryClientProvider client={queryClient}>
        <Outlet />
        <ReactQueryDevtools />
      </QueryClientProvider>
    </HeroUIProvider>
  );
}
